module.exports = __webpack_public_path__ + "img/news-small-3.d8fa11ec.png";